import { BaseService } from './BaseService';
import { CreateRegistroJornadaDto, RegistroJornadaResponseDto, GuardarMinutajeRequest } from '../types';

/**
 * Servicio para gestionar registros de minutaje
 */
class MinutajeService extends BaseService {
  constructor() {
    super('/registros-jornada');
  }

  /**
   * Obtiene registros de minutaje por jornada
   * @param jornadaId ID de la jornada
   * @returns Promise con los registros de la jornada
   */
  async obtenerRegistrosPorJornada(jornadaId: number): Promise<RegistroJornadaResponseDto[]> {
    const response = await this.get<RegistroJornadaResponseDto[]>(`jornada/${jornadaId}`);
    return response.data;
  }

  /**
   * Crea un registro de minutaje
   * @param registro Datos del registro a crear
   * @returns Promise con el registro creado
   */
  async crearRegistro(registro: CreateRegistroJornadaDto): Promise<RegistroJornadaResponseDto> {
    const response = await this.create<RegistroJornadaResponseDto>(registro);
    return response.data;
  }

  /**
   * Guarda múltiples registros de minutaje para una jornada
   * @param request Datos de los registros a guardar
   * @returns Promise con los registros guardados
   */
  async guardarMinutaje(request: GuardarMinutajeRequest): Promise<RegistroJornadaResponseDto[]> {
    const registrosGuardados: RegistroJornadaResponseDto[] = [];
    
    // Guardar cada registro individualmente
    for (const registro of request.registros) {
      try {
        const registroGuardado = await this.crearRegistro(registro);
        registrosGuardados.push(registroGuardado);
      } catch (error) {
        throw error;
      }
    }
    
    return registrosGuardados;
  }

  /**
   * Actualiza un registro de minutaje
   * @param registroId ID del registro
   * @param registro Datos actualizados
   * @returns Promise con el registro actualizado
   */
  async actualizarRegistro(registroId: number, registro: Partial<CreateRegistroJornadaDto>): Promise<RegistroJornadaResponseDto> {
    const response = await this.update<RegistroJornadaResponseDto>(registroId, registro);
    return response.data;
  }

  /**
   * Elimina un registro de minutaje
   * @param registroId ID del registro a eliminar
   */
  async eliminarRegistro(registroId: number): Promise<void> {
    await this.delete(registroId);
  }
}

// Exportar instancia del servicio
export const minutajeService = new MinutajeService();
export default MinutajeService;